export const accountIcon = (
  <svg viewBox="0 0 21 20" fill="none">
    <path
      d="M10.6899 2.5C14.8321 2.5 18.1899 5.85786 18.1899 10C18.1899 14.1421 14.8321 17.5 10.6899 17.5C6.54781 17.5 3.18994 14.1421 3.18994 10C3.18994 5.85786 6.54781 2.5 10.6899 2.5Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6899 7.5C12.4158 7.5 13.8149 8.89911 13.8149 10.625C13.8149 12.3509 12.4158 13.75 10.6899 13.75C8.96405 13.75 7.56494 12.3509 7.56494 10.625C7.56494 8.89911 8.96405 7.5 10.6899 7.5Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.67432 4.42188C6.14456 5.34812 6.8621 6.12605 7.7474 6.66945C8.6327 7.21285 9.65117 7.50049 10.6899 7.50049C11.7287 7.50049 12.7472 7.21285 13.6325 6.66945C14.5178 6.12605 15.2353 5.34812 15.7056 4.42188"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const bellIcon = (
  <svg viewBox="0 0 16 16" fill="none">
    <path
      d="M13.8124 10.9938C13.4437 10.3563 12.9999 9.14375 12.9999 7V6.55625C12.9999 3.7875 10.7749 1.51875 8.03744 1.5H7.99994C7.3431 1.49918 6.69255 1.62795 6.08555 1.87893C5.47855 2.12991 4.92703 2.49818 4.46257 2.96264C3.99811 3.42709 3.62985 3.97861 3.37886 4.58561C3.12788 5.19261 2.99911 5.84316 2.99994 6.5V7C2.99994 9.14375 2.55619 10.3563 2.18744 10.9938C2.0963 11.1455 2.04763 11.319 2.04653 11.496C2.04543 11.673 2.09194 11.8471 2.18119 12C2.26869 12.1529 2.39525 12.2797 2.5479 12.3676C2.70055 12.4554 2.87381 12.5011 3.04994 12.5H12.9499C13.1261 12.5011 13.2993 12.4554 13.452 12.3676C13.6046 12.2797 13.7312 12.1529 13.8187 12C13.9079 11.8471 13.9544 11.673 13.9533 11.496C13.9522 11.319 13.9036 11.1455 13.8124 10.9938Z"
      fill="currentColor"
    />
    <path
      d="M9.99371 13.5H5.99371C5.86111 13.5 5.73393 13.5527 5.64016 13.6464C5.54639 13.7402 5.49371 13.8674 5.49371 14C5.49371 14.1326 5.54639 14.2598 5.64016 14.3536C5.73393 14.4473 5.86111 14.5 5.99371 14.5H9.99371C10.1263 14.5 10.2535 14.4473 10.3473 14.3536C10.441 14.2598 10.4937 14.1326 10.4937 14C10.4937 13.8674 10.441 13.7402 10.3473 13.6464C10.2535 13.5527 10.1263 13.5 9.99371 13.5Z"
      fill="currentColor"
    />
  </svg>
);
export const clusterIcon = (
  <svg viewBox="0 0 13 19" fill="none">
    <path
      d="M10.8796 12.3685V7.13149C10.8793 7.05265 10.8603 6.97531 10.8247 6.90728C10.7891 6.83924 10.7381 6.78292 10.6769 6.74398L6.52283 4.11443C6.46419 4.07653 6.39767 4.05658 6.32996 4.05658C6.26225 4.05658 6.19573 4.07653 6.13709 4.11443L1.98303 6.74398C1.92178 6.78292 1.87079 6.83924 1.83519 6.90728C1.79959 6.97531 1.78065 7.05265 1.78027 7.13149V12.3685C1.78065 12.4473 1.79959 12.5246 1.83519 12.5927C1.87079 12.6607 1.92178 12.717 1.98303 12.756L6.13709 15.3855C6.19573 15.4234 6.26225 15.4434 6.32996 15.4434C6.39767 15.4434 6.46419 15.4234 6.52283 15.3855L10.6769 12.756C10.7381 12.717 10.7891 12.6607 10.8247 12.5927C10.8603 12.5246 10.8793 12.4473 10.8796 12.3685Z"
      stroke="currentColor"
      strokeWidth="0.885744"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const dashboardIcon = (
  <svg viewBox="0 0 13 16" fill="none">
    <path
      d="M1.18677 11.1001V9.83237C1.18677 6.64923 3.4715 4.02521 6.31011 4.01414C6.98718 4.01123 7.6581 4.15799 8.28438 4.44602C8.91065 4.73405 9.47996 5.15767 9.95964 5.69258C10.4393 6.22749 10.8199 6.86315 11.0796 7.56311C11.3393 8.26307 11.473 9.01355 11.473 9.77148V11.1001C11.473 11.2175 11.4313 11.3302 11.3571 11.4132C11.2829 11.4963 11.1823 11.543 11.0774 11.543H1.58239C1.47747 11.543 1.37684 11.4963 1.30264 11.4132C1.22845 11.3302 1.18677 11.2175 1.18677 11.1001Z"
      stroke="currentColor"
      strokeWidth="0.885744"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.33008 4.01416V5.78565"
      stroke="currentColor"
      strokeWidth="0.885744"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.35986 8.28232L2.89291 8.7418"
      stroke="currentColor"
      strokeWidth="0.885744"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.3001 8.28232L9.76709 8.7418"
      stroke="currentColor"
      strokeWidth="0.885744"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.11353 11.543L8.49612 6.6105"
      stroke="currentColor"
      strokeWidth="0.885744"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const containerIcon = (
  <svg viewBox="0 0 13 16" fill="none">
    <path
      d="M2.13306 12.3823V8.43823H4.84774"
      stroke="currentColor"
      strokeWidth="0.876463"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.0527 12.3823H1.35742"
      stroke="currentColor"
      strokeWidth="0.876463"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.84766 12.3823V5.80884H7.56234"
      stroke="currentColor"
      strokeWidth="0.876463"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.2769 3.17944H7.56226V12.3823H10.2769V3.17944Z"
      stroke="currentColor"
      strokeWidth="0.876463"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const nodeIcon = (
  <svg viewBox="0 0 14 16" fill="none">
    <path
      d="M10.3905 3.12842H3.26928C2.83228 3.12842 2.47803 3.52498 2.47803 4.01416V11.9859C2.47803 12.475 2.83228 12.8716 3.26928 12.8716H10.3905C10.8275 12.8716 11.1818 12.475 11.1818 11.9859V4.01416C11.1818 3.52498 10.8275 3.12842 10.3905 3.12842Z"
      stroke="currentColor"
      strokeWidth="0.885744"
    />
    <path
      d="M10.3905 3.12842H3.26928C2.83228 3.12842 2.47803 3.52498 2.47803 4.01416V11.9859C2.47803 12.475 2.83228 12.8716 3.26928 12.8716H10.3905C10.8275 12.8716 11.1818 12.475 11.1818 11.9859V4.01416C11.1818 3.52498 10.8275 3.12842 10.3905 3.12842Z"
      stroke="currentColor"
      strokeWidth="0.885744"
    />
    <path
      d="M7.81918 6.00708H5.84105C5.40406 6.00708 5.0498 6.40364 5.0498 6.89282V9.10718C5.0498 9.59637 5.40406 9.99293 5.84105 9.99293H7.81918C8.25618 9.99293 8.61043 9.59637 8.61043 9.10718V6.89282C8.61043 6.40364 8.25618 6.00708 7.81918 6.00708Z"
      stroke="currentColor"
      strokeWidth="0.885744"
    />
  </svg>
);
export const chevronBottom = (
  <svg viewBox="0 0 16 16" fill="none">
    <path
      d="M13 6L8 11L3 6"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const chevronRight = (
  <svg width="6" height="10" viewBox="0 0 6 10" fill="none">
    <path
      d="M5.08662 5.426C5.1975 5.30505 5.25 5.15011 5.25 4.99998C5.25 4.84986 5.1975 4.69492 5.08662 4.57396L1.75336 0.937662C1.52399 0.687284 1.14267 0.687649 0.913452 0.937545C0.695488 1.17517 0.695562 1.55201 0.913398 1.78965L3.8562 4.99998L0.913452 8.21026C0.913442 8.21027 0.913409 8.21031 0.913398 8.21032C0.695403 8.44802 0.695736 8.82476 0.913344 9.0623C1.14263 9.3126 1.524 9.31251 1.75331 9.06236L5.08662 5.426Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.5"
    />
  </svg>
);
export const chevronLeft = (
  <svg width="6" height="10" viewBox="0 0 6 10" fill="none">
    <path
      d="M0.913376 5.426C0.802501 5.30505 0.75 5.15011 0.75 4.99998C0.75 4.84986 0.802501 4.69492 0.913377 4.57396L4.24664 0.937662C4.47601 0.687284 4.85733 0.687649 5.08655 0.937545C5.30451 1.17517 5.30444 1.55201 5.0866 1.78965L2.1438 4.99998L5.08655 8.21026C5.08656 8.21027 5.08659 8.21031 5.0866 8.21032C5.3046 8.44802 5.30426 8.82476 5.08666 9.0623C4.85737 9.3126 4.476 9.31251 4.24669 9.06236L0.913376 5.426Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.5"
    />
  </svg>
);
export const filterIcon = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g clipPath="url(#clip0_1_59)">
      <path d="M7 11L5 13L3 11" fill="currentColor" />
      <path
        d="M7 11L5 13L3 11"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M5 3V13V3Z" fill="currentColor" />
      <path
        d="M5 3V13"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M9 5L11 3L13 5" fill="currentColor" />
      <path
        d="M9 5L11 3L13 5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M11 13V3V13Z" fill="currentColor" />
      <path
        d="M11 13V3"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_59">
        <rect width="16" height="16" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);
export const arrowRight = (
  <svg width="12" height="6" viewBox="0 0 12 6" fill="none">
    <path d="M9 1L11 3L9 5" fill="url(#paint0_linear_1_145)" />
    <path
      d="M9 1L11 3L9 5"
      stroke="#A9A9A9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M1 3L11 3L1 3Z" fill="url(#paint1_linear_1_145)" />
    <path
      d="M1 3L11 3"
      stroke="#A9A9A9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1_145"
        x1="11"
        y1="3"
        x2="9"
        y2="3"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#051922" stopOpacity="0.29" />
        <stop offset="1" stopColor="#051922" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1_145"
        x1="11"
        y1="3.5"
        x2="1"
        y2="3.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#051922" stopOpacity="0.29" />
        <stop offset="1" stopColor="#051922" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);
